import React, { useState, useRef, useEffect, useMemo } from 'react';
import styles from './CreateFaculty.module.scss';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import CreateNewsHeader from '../../../Molecules/NewsAndEvents/CreateNewsHeader';
import folderIcon from '../../../../assets/Imagess/folderICon.svg';
import CustomSelect from '../../../Atoms/forms/customSelect/CustomSelect';
import uploadIcon from '../../../../assets/Imagess/upload-icon.svg';
import gradIcon from '../../../../assets/Imagess/grad-hat.svg';
import globeIcon from '../../../../assets/Imagess/globeIcon.svg';
import mailIcon from '../../../../assets/Imagess/mail.svg';
import mobile from '../../../../assets/Imagess/mobile.svg';
import { useMutation } from 'react-query';
import axios from 'axios';
import { API_URL, securityHeaders } from '../../../../Constants';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-quill/dist/quill.snow.css';
import { isEmpty } from 'lodash';
import memberAdded from '../../../../assets/Imagess/member-added.png';
import { useFetchPositions } from '../../../../Hooks/Settings';
import { useFetchTeamById, useFetchTeams } from '../../../../Hooks/Teams';
import TextInput from '../../../Atoms/Inputs/TextInput';
import noImageFound from '../../../../assets/Imagess/no-image-found.jpg';
import { useToast } from '../../../Molecules/Custom/CustomToaster/Toast';
import Loader from '../../../Molecules/Loader/Loader';
// import { useFetchDegrees } from '../../../../Hooks/Programs';
import { sanitizeAndValidateUrl } from '../../../../app/helpers/sanitizeAndValidateUrl';
import Toggle from '../../../Atoms/Inputs/Toggle';
import hashIcon from '../../../../assets/Imagess/hash.svg';

const UpdateFacultyMember = () => {
  const { id } = useParams();
  const fileInputRef = useRef(null);
  const formikRef = useRef(null);
  const navigate = useNavigate();
  const [imageSrc, setImageSrc] = useState('');
  const [showCheckmark, setShowCheckmark] = useState(false);
  const { data: positions } = useFetchPositions();
  const { data, isLoading, refetch } = useFetchTeamById(id);
  const customizedToast = useToast();
  // const { data: degrees } = useFetchDegrees(100, 1);
  const { data: teamsData, isLoading: isLoadingTeams } = useFetchTeams(
    1,
    10000,
    ''
  );
  const languageOptions = [
    {
      value: 'English',
      text: 'الإنجليزية',
    },
    {
      value: 'Arabic and English',
      text: 'العربية والإنجليزية',
    },
  ];
  useEffect(() => {
    if (!isEmpty(id) && undefined !== id) {
      refetch();
    }
  }, [id]);

  useEffect(() => {
    if (!isEmpty(data)) {
      const memberData = data?.data[0];

      formikRef.current.setValues({
        nameAr: memberData.fullName_AR || '',
        academicDegreeAr: memberData.educationAR || '',
        email: memberData.email || '',
        language: memberData.languages || '',
        position: memberData.positionId || '',
        phoneNumber: memberData.phoneNumber || '',
        isActive: memberData.isActive || false,
        OrderId: memberData.orderId,
      });
      setImageSrc(
        sanitizeAndValidateUrl(
          `${data?.data[0]?.url}${data?.data[0]?.facultyImage}`
        )
      );
    }
  }, [data]);
  const validationSchema = Yup.object().shape({
    nameAr: Yup.string().required('Arabic member name is required'),
    academicDegreeAr: Yup.string().required(
      'Arabic academic Degree is required'
    ),
    email: Yup.string().required('Email is required'),
    language: Yup.string().required('Language is required'),
    position: Yup.string().required('Position is required'),
    isActive: Yup.boolean().required('Active is required'),
    OrderId: Yup.number()
      .transform((value, originalValue) => {
        const v = String(originalValue ?? '').trim();
        return v === '' ? undefined : Number(v);
      })
      .typeError('رقم الترتيب يجب أن يكون رقمًا')
      .integer('رقم الترتيب يجب أن يكون عددًا صحيحًا')
      .required('رقم الترتيب مطلوب'),
    // image:
    //   !isEmpty(id) && undefined !== id
    //     ? Yup.mixed().notRequired()
    //     : Yup.mixed().required("Image is required"),
  });

  const createMember = useMutation({
    mutationFn: (fields) => {
      return axios.post(API_URL + `/api/Degree/DegreeFaculty`, fields, {
        headers: securityHeaders,
      });
    },
    onSuccess: () => {
      // setShowCheckmark(true);
      customizedToast.open(
        id ? 'Faculty member is updated' : 'Faculty member is created'
      );
      setTimeout(() => {
        formikRef.current.resetForm();
        navigate(-1);
      }, 2000);
    },
    onError: (error) => {
      toast.error(error?.message);
    },
  });

  const handleSubmit = (values) => {
    var formData = new FormData();
    formData.append('FullName_AR', values.nameAr);
    formData.append('PositionId', values.position);
    formData.append('Languages', values.language);
    formData.append('Email', values.email);
    formData.append('EducationAr', values.academicDegreeAr);
    formData.append('PhoneNumber', values.phoneNumber);
    formData.append('isActive', values.isActive);
    formData.append('OrderId', values.OrderId);

    const memberId = id ? id : '00000000-0000-0000-0000-000000000000';
    formData.append('FacultyId', memberId);
    if (undefined !== values.image) {
      formData.append('FacultyImage', values.image);
    }
    createMember.mutate(formData);
  };

  const triggerFormSubmission = () => {
    formikRef.current.submitForm();
  };
  const membersList = teamsData?.data?.items ?? [];

  const membersCount = Array.isArray(membersList) ? membersList.length : 0;

  const existingOrder = Number(data?.data?.[0]?.orderId ?? 0);

  const maxOrder = Math.max(membersCount + (id ? 0 : 1), existingOrder, 1);
  const orderOptions = useMemo(() => {
    return Array.from({ length: maxOrder }, (_, i) => {
      const n = i + 1;
      return { value: n, text: String(n) };
    });
  }, [maxOrder]);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div className={styles['action-programs']}>
      <div className={styles['container']}>
        <CreateNewsHeader
          handleSubmit={triggerFormSubmission}
          title={!isEmpty(id) ? 'تعديل عضو هيئة تدريس' : 'إضافة عضو جديد'}
        />
      </div>{' '}
      <div className={styles['container']} style={{ paddingTop: '0px' }}>
        <Formik
          innerRef={formikRef}
          initialValues={{
            nameAr: data?.data[0]?.fullName_AR || '',
            academicDegreeAr: data?.data[0]?.educationAR || '',
            email: data?.data[0]?.email || '',
            language: data?.data[0]?.languages || '',
            position: data?.data[0]?.positionId || '',
            image: null,
            phoneNumber: data?.data[0]?.phoneNumber || '',
            isActive: data?.data[0]?.isActive || false,
            OrderId: data?.data?.[0]?.orderId,
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, errors, touched }) => {
            return (
              <Form>
                <div className={styles['steps']}>
                  <Toggle
                    name='isActive'
                    value={values.isActive}
                    onChange={(e) => {
                      setFieldValue('isActive', e.target.checked);
                    }}
                    isActive={values.isActive}
                    text='نشط'
                    errors={errors.isActive}
                    touched={touched.isActive}
                  />
                </div>
                <div className={styles.steps}>
                  <CustomSelect
                    label='التسلسل'
                    placeholder={
                      isLoadingTeams ? 'جارٍ التحميل...' : 'اختر رقم الترتيب'
                    }
                    icon={hashIcon}
                    style={{ width: '100%', justifyContent: 'flex-start' }}
                    iconStyle={{ marginLeft: '0px', paddingLeft: '15px' }}
                    dropdownStyle={{ marginTop: '4px' }}
                    value={values.OrderId}
                    name='OrderId'
                    onChange={(name, v) => {
                      setFieldValue(name, Number(v));
                    }}
                    options={orderOptions}
                    touched={touched.OrderId}
                    errors={errors.OrderId}
                    type='category'
                    right
                  />

                  <TextInput
                    label='الاسم'
                    placeholder='أدخل الاسم'
                    icon={folderIcon}
                    style={{
                      width: '100%',
                      justifyContent: 'flex-start',
                    }}
                    containerStyle={{ padding: '0px' }}
                    errors={errors.nameAr}
                    touched={touched.nameAr}
                    value={values.nameAr}
                    name='nameAr'
                    onChange={(name, value) => {
                      setFieldValue(name, value);
                    }}
                  />
                  <TextInput
                    label='الدرجة الأكاديمية'
                    placeholder='أدخل الدرجة الأكاديمية'
                    icon={gradIcon}
                    style={{
                      width: '100%',
                      justifyContent: 'flex-start',
                    }}
                    containerStyle={{ padding: '0px' }}
                    errors={errors.academicDegreeAr}
                    touched={touched.academicDegreeAr}
                    value={values.academicDegreeAr}
                    name='academicDegreeAr'
                    onChange={(name, value) => {
                      setFieldValue(name, value);
                    }}
                  />

                  <CustomSelect
                    label='منصب'
                    placeholder='اختر المنصب'
                    icon={folderIcon}
                    style={{ width: '100%' }}
                    iconStyle={{ marginLeft: '0px', paddingLeft: '15px' }}
                    dropdownStyle={{ marginTop: '4px' }}
                    value={values.position}
                    name='position'
                    onChange={(name, e) => {
                      setFieldValue(name, e);
                    }}
                    options={positions?.data?.map((option) => ({
                      value: option.positionId,
                      text: option.positionAR,
                    }))}
                    touched={touched.position}
                    errors={errors.position}
                    type='category'
                    right
                  />
                  <CustomSelect
                    label='اللغة'
                    placeholder='اختر اللغة'
                    icon={globeIcon}
                    style={{ width: '100%', zIndex: 2 }}
                    iconStyle={{ marginLeft: '0px', paddingLeft: '15px' }}
                    dropdownStyle={{ marginTop: '4px' }}
                    value={values.language}
                    onChange={(name, e) => {
                      setFieldValue(name, e);
                    }}
                    options={languageOptions}
                    type='category'
                    name='language'
                    touched={touched.language}
                    errors={errors.language}
                    right
                  />
                  <TextInput
                    label='البريد الإلكتروني'
                    placeholder='أدخل البريد الإلكتروني'
                    icon={mailIcon}
                    style={{
                      width: '100%',
                      justifyContent: 'flex-start',
                    }}
                    containerStyle={{ padding: '0px' }}
                    errors={errors.email}
                    touched={touched.email}
                    value={values.email}
                    name='email'
                    onChange={(name, value) => {
                      setFieldValue(name, value);
                    }}
                  />
                  <TextInput
                    label='الهاتف المحمول'
                    placeholder='أدخل الهاتف المحمول'
                    icon={mobile}
                    style={{
                      width: '100%',
                      justifyContent: 'flex-start',
                    }}
                    errors={errors.phoneNumber}
                    touched={touched.phoneNumber}
                    value={values.phoneNumber}
                    name='phoneNumber'
                    onChange={(name, value) => {
                      setFieldValue(name, value);
                    }}
                  />
                </div>

                {errors.image && (
                  <div
                    className={styles['error-message']}
                    style={{ marginTop: '30px' }}
                  >
                    <p>{errors.image}</p>
                  </div>
                )}
                <div style={{ marginTop: '30px' }}>
                  <label>رفع الصورة</label>
                </div>
                <div
                  className={styles['upload-container']}
                  onClick={() => fileInputRef.current.click()}
                  style={{ marginTop: '30px' }}
                >
                  <input
                    type='file'
                    accept='image/*'
                    className='form-control form-body-input'
                    style={{ display: 'none' }}
                    ref={fileInputRef}
                    onChange={(event) =>
                      setFieldValue('image', event.currentTarget.files[0])
                    }
                  />
                  {values.image ? (
                    <img
                      className={styles['uploaded-image']}
                      src={URL.createObjectURL(values.image)}
                      alt='selected-image'
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = noImageFound;
                      }}
                    />
                  ) : imageSrc ? (
                    <img
                      className={styles['uploaded-image']}
                      src={imageSrc}
                      alt='selected-image'
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null;
                        currentTarget.src = noImageFound;
                      }}
                    />
                  ) : (
                    <div className={styles['upload-icon-container']}>
                      <img className={styles['upload-icon']} src={uploadIcon} />
                      <div className={styles['text-container']}>
                        <p className={styles['select-image']}>
                          حدد صورة للتحميل
                        </p>
                        <p className={styles['size']}>
                          {' '}
                          الحد الأقصى للحجم: <span dir='ltr'>100 MB</span>{' '}
                        </p>
                        <p className={styles['size']}>
                          العرض: 378 الارتفاع: 303
                        </p>
                      </div>
                    </div>
                  )}
                </div>

                <button
                  type='submit'
                  className={styles['submit-button']}
                  style={{ display: 'none' }}
                >
                  Submit
                </button>
              </Form>
            );
          }}
        </Formik>
      </div>
      {showCheckmark && (
        <div className={styles['checkmark']}>
          <img src={memberAdded} />
        </div>
      )}
    </div>
  );
};

export default UpdateFacultyMember;
